module.exports = __webpack_public_path__ + "media/images/talent/bg-mv-sp-9a4014eaf28b841541fc83f63d14f818.png";